import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useLang } from "../i18n";
import { useConsent } from "./CookieBanner";

export default function Footer() {
  const { t } = useLang();
  const { reset } = useConsent();
  return (
    <footer className="bg-charcoal text-ivory mt-auto">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-20 grid gap-14 md:grid-cols-3">
        <div>
          <Logo dark />
          <p className="mt-8 text-sm text-ivory/60 max-w-xs leading-relaxed">{t("footer.tagline")} · {t("footer.shipping")}</p>
        </div>
        <div>
          <p className="eyebrow !text-ivory/50 mb-5">{t("footer.nav")}</p>
          <ul className="space-y-3 text-sm">
            {[["/atelier", t("nav.atelier")], ["/collezione", t("nav.collection")], ["/noleggio", t("nav.rental")], ["/appuntamenti", t("nav.appointments")]].map(([to, label]) => (
              <li key={to}><Link to={to} className="text-ivory/75 hover:text-gold transition-colors" data-testid={`footer-link-${to.slice(1)}`}>{label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="eyebrow !text-ivory/50 mb-5">{t("footer.contact")}</p>
          <ul className="space-y-3 text-sm text-ivory/75">
            <li>{t("appointments.address")}</li>
            <li>{t("appointments.hours")}</li>
            <li>{t("footer.shipping")}</li>
            <li><a href="mailto:info@perleibridal.com" className="hover:text-gold transition-colors" data-testid="footer-email">info@perleibridal.com</a></li>
            <li><a href="tel:+393514728860" className="hover:text-gold transition-colors" data-testid="footer-phone">+39 3514728860</a></li>
            <li><a href="https://www.instagram.com/per_lei_bridal_official/" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-testid="footer-instagram">Instagram: @per_lei_bridal_official</a></li>
            <li><span data-testid="footer-wechat">WeChat: PerLeiBridal</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ivory/10 py-6 flex flex-col items-center gap-3 text-[11px] tracking-[0.2em] uppercase text-ivory/40">
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-6">
          <span>© {new Date().getFullYear()} Per Lei Bridal — P. IVA 04761060161</span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-6">
          <Link to="/privacy" className="hover:text-gold transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
          <span className="text-ivory/20">·</span>
          <Link to="/cookie-policy" className="hover:text-gold transition-colors" data-testid="footer-cookies-link">Cookie Policy</Link>
          <span className="text-ivory/20">·</span>
          <button onClick={reset} className="hover:text-gold transition-colors uppercase tracking-[0.2em]" data-testid="footer-cookie-settings">Cookie Settings</button>
        </div>
      </div>
    </footer>
  );
}
